<template>
    <div class="input_box">
        <input type="text" id="search_pc" v-model="searchText">
        <img src="../assets/images/search_2_line.svg" alt="search_icon">
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        name: "SearchInput",
        props: {
        },
        data: () => ({
        }),
        computed: {
            ...mapState('search', ["search_text"]),
            searchText: {
                get() {
                    return this.search_text;
                },
                set(value) {
                    this.updateSearchText(value.trim());
                }
            }
        },
        created() {
        },
        watch: {
        },
        methods: {
            ...mapMutations('search', ['updateSearchText']),
        }
    }
</script>

<style scoped lang="scss">
    .input_box {
        position: relative;
        border: solid 2px #826E67;
        border-radius: 5px;
        box-sizing: border-box;
        height: 30px;
        width: 200px;
        display: flex;
        align-items: center;
        input {
            font-size: 13px;
            width: 160px;
            border: none;
            color: #826E67;
            padding-left: 5px;
            &:focus {
                outline: none;
            }
        }
        img {
            position: absolute;
            right: 5px;
        }
    }
</style>
